import { parseProgramOfferings } from 'legacy/lut/services/partner360/configuration/helpers/parseProgramOfferings'

import type { IFinancialCockpitState } from '../model/types'

export const getCockpitMetricOffering = ({
  selectedOffering,
  partnerData,
  offerings,
}: Pick<IFinancialCockpitState, 'selectedOffering' | 'partnerData' | 'offerings'>) => {
  const offeringName = offerings.find((item) => item.offering === selectedOffering)?.offeringName

  return parseProgramOfferings(partnerData[0]?.AllProgramOfferingsJson ?? '[]').find(
    (item) => item.Offering === selectedOffering || item.Offering === offeringName
  )
}
